import { render, staticRenderFns } from "./TravelInfoEdit.vue?vue&type=template&id=542b0d7f&scoped=true"
import script from "./TravelInfoEdit.vue?vue&type=script&lang=js"
export * from "./TravelInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./TravelInfoEdit.vue?vue&type=style&index=0&id=542b0d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b0d7f",
  null
  
)

export default component.exports